import { useRef } from "react";
import { createPortal } from "react-dom";
import { useModalFocus } from "../hooks/useModalFocus";

// A picture open full screen (components/ChatMessage.jsx,
// ImageGalleryPanel.jsx), as a modal dialog (audit client-09): announced as
// one (role="dialog", aria-modal, `label`), Escape or a click beside the
// picture closes it, Tab stays inside, and the focus goes back to what
// opened it (hooks/useModalFocus.js).
//
// Portaled straight to <body>: a chat bubble's row has a `fade-up` CSS
// animation, and per spec any ancestor with an active/filled
// transform-affecting animation becomes the containing block for
// `position: fixed` descendants — rendered in place, the viewer was pinned
// to that bubble's own box instead of covering the screen. A click on it
// stops here: React still bubbles a portal's events up the component tree,
// into the panel that opened it, whose own backdrop closes that panel.
// zClass: its layer, a literal Tailwind class ("z-[100]").
export default function Lightbox({ label, onClose, testId, zClass = "z-[100]", children }) {
  const ref = useRef(null);
  useModalFocus(ref, { onEscape: onClose });
  return createPortal(
    <div ref={ref} role="dialog" aria-modal="true" aria-label={label} tabIndex={-1}
      className={`fixed inset-0 ${zClass} flex items-center justify-center bg-black/85 px-4 outline-none`}
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }} data-testid={testId}>
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-[min(94vw,1536px)] flex flex-col items-center gap-3">
        {children}
      </div>
    </div>,
    document.body
  );
}
